module.exports = __webpack_public_path__ + "static/media/viatris.c1313618.png";